<template>
  <div style="margin-left: 8px">
    <img src="../../assets/EBG.jpg" style="transform: scale(0.5); position: absolute;top: -400px;left: -400px;">
  </div>
</template>
<script>
export default {
  name: 'ProjectPhaseDescEBG'
};
</script>
<style scoped>

</style>
